import * as fromExperiencesActions from '@ordersnproducts/modules/order-builder/modules/location/actions/experiences-actions/experiences.actions';
import { Experience } from '@cemex-core/cmx-api';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { Feature } from '@cemex-core/cmx-api/models/experiences/experience.model';

export interface State {
  activeExperienceCode: string;
  features: Feature[];
  activeExperienceId: number;
  isOnline: number;
  loading: boolean;
}

const initialState: State = {
  activeExperienceCode: undefined,
  features: [],
  activeExperienceId: undefined,
  isOnline: undefined,
  loading: false,
};

export function reducer(state = initialState, action: fromExperiencesActions.Actions): State {
  switch (action.type) {
    case fromExperiencesActions.ActionTypes.SET_EXPERIENCE: {
      const payload: Experience = action.payload;
      return {
        ...state,
        loading: false,
        activeExperienceCode: payload.experienceCode,
        features: payload.features,
        isOnline: payload.isOnline,
        activeExperienceId: payload.experienceId,
      };
    }
    case fromExperiencesActions.ActionTypes.FETCH: {
      return {
        ...state,
        loading: true,
      };
    }
    case fromExperiencesActions.ActionTypes.SET_DEFAULT: {
      return {
        ...state,
        loading: false,
        activeExperienceCode: ORDER_EXPERIENCES.REQUEST,
        isOnline: 0,
        activeExperienceId: 1,
      };
    }
    case fromExperiencesActions.ActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
